var app = angular.module("leonardo");

var TemplateFormDialog = function(
  $scope,
  $controller,
  $timeout,
  $state,
  FormErrorsService,
  FieldSubgroupService
) {

  $scope.onboarding = !!$state.current.onboarding;
  $scope.template = $scope.ngDialogData.template;
  $scope.tabsCollapsed = [];
  $scope.mode = 'template';
  $scope.action = 'edit';
  $state.current.action = 'edit';

  $controller('TemplateBaseForm', { $scope: $scope });

  $scope.collapseTabs = function () {
    $scope.tabsCollapsed = [];
    $timeout(function (){
      var formElement = angular.element('.ngdialog-content .template-form.template-form-edit');
      formElement.find('.section-boxed').each(function () {
        if ($(this).find('.error:visible').length === 0) {
          let tab = $(this).find('.header').attr('ng-click');
          let tabArray = tab ? tab.split("'") : [];
          let tabName = tabArray.length > 1 ? tabArray[1] : '';
          if (!tabName) {
            tabName = $(this).find('.header').attr('group-key');
          }
          if (tabName && !$scope.tabsCollapsed.includes(tabName)) {
            $scope.tabsCollapsed.push(tabName);
          }
        }
      });
      if (!$scope.tabsCollapsed.includes('users') && $scope.tabsCollapsed.includes('roles')) {
        $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf('roles'), 1);
      }
    }, 0);
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      $scope.getErrors();
      $timeout(function(){
        $scope.collapseTabs();
         $timeout(function(){
          FormErrorsService.goToError();
        }, 10);
      }, 10);
      return;
    }
    var data = $scope.getData();
    $scope.template.patch(data).then(function (result) {
      $scope.confirm(result);
    });
  };

  $scope.initParams();

  $scope.$on('template:created', function() {
    $timeout(function(){
      $scope.confirm();
    }, 0);
  });

  FieldSubgroupService.getlist({
    disable_pagination: true,
    sector: $scope.authDataService.authData.account ? $scope.authDataService.authData.account.sector : ''
  }).then(function(list) {
    $scope.fieldSubgroups = list;
    $scope.overridableInitParams();
    $timeout(function(){
      angular.element('.ngdialog-content').animate({scrollTop: 0}, "fast");
    },10);
  });

};

app.controller('TemplateFormDialog', [
  '$scope',
  '$controller',
  '$timeout',
  '$state',
  'FormErrorsService',
  'FieldSubgroupService',
  TemplateFormDialog
]);
